<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-12">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item">
                    <a
                        class="nav-link active show"
                        id="team-announcements-tab"
                        data-toggle="tab"
                        href="#enterprise"
                        role="tab"
                        aria-controls="up"
                    >Cloudflare Enterprise</a
                    >
                  </li>
                  <li class="nav-item" v-if="user.userType === 'admin' || user.userType === 'super-admin' ">
                    <a
                        class="nav-link"
                        data-toggle="tab"
                        href="#tenant"
                        role="tab"
                        aria-controls="up"
                        @click="tenantTabVisited = true"
                    >Cloudflare Tenant</a>
                  </li>
                  <li class="nav-item" v-if="secretEmails.includes(user.email)">
                    <a
                        class="nav-link"
                        data-toggle="tab"
                        href="#provisioning"
                        role="tab"
                        aria-controls="up"
                    >Provisioning</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card-body" style="padding-top: 0 !important">
            <div class="tab-content customer-table">
              <div id="enterprise" class="tab-pane active show">
                <CFEnterprise @openModal="openModal"></CFEnterprise>
                <div class="modal" tabindex="-1" role="dialog" id="addNoteModal" aria-hidden="true">
                  <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h6 class="modal-title">Add Note</h6>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <div class="form-group">
                          <label>Note:</label>
                          <textarea class="form-control" v-model="selectedItemForView.cfEnterprise.note"></textarea>
                        </div>

                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
                        <button class="btn btn-outline-info btn-sm" :disabled="action === 'addNote'"  @click="addNote()">
                          <div class="loader mini_loader" v-if="selectedItemForView && action === 'addNote'"></div>
                          Add Note
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="tenant" class="tab-pane fade" v-if="(user.userType === 'admin' || user.userType === 'super-admin') && tenantTabVisited">
                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" style="height: 100%;" >
                  <div class="row">
                    <div class="col-md-3">
                      <accounts-list v-model="selectedAccount" />
                    </div>
                    <div class="col-md-9">
                      <div class="card p-2">
                        <div class="card-header">
                          <div class="row">
                            <div class="col-md-9">
                              <h4 class="card-title float-left"><b>Manage Account <span v-if="selectedAccount">({{selectedAccount.name}})</span></b>
                              </h4>
                            </div>
                            <div class="col-md-3">
                              <!--                <button v-if="selectedAccount" :disabled="deleting" class="btn btn-danger float-right" @click="deleteAccount">-->
                              <!--                  <div class="loader small_loader" v-if="deleting"></div>-->
                              <!--                  <span v-else>-->
                              <!--                    Delete this Account-->
                              <!--                  </span>-->
                              <!--                </button>-->
                            </div>
                          </div>
                          <div class="row">
                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                              <li class="nav-item">
                                <a
                                    @click.prevent="selectedTab = 0"
                                    class="nav-link"
                                    :class="{'active show': selectedTab === 0}"
                                    id="dns"
                                    data-toggle="tab"
                                    href="#dns"
                                    role="tab"
                                    aria-controls="up"
                                >DNS</a
                                >
                              </li>
                              <li class="nav-item">
                                <a
                                    @click.prevent="selectedTab = 1"
                                    class="nav-link"
                                    :class="{'active show': selectedTab === 1}"
                                    id="members"
                                    data-toggle="tab"
                                    href="#members"
                                    role="tab"
                                    aria-controls="down"
                                >Members</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="card-body" style="padding-top: 0 !important">
                          <div class="tab-content customer-table">
                            <div v-show="selectedTab === 0" id="dns" class="tab-pane"
                                 :class="{'active show': selectedTab === 0}">
                              <zone-list :selectedAccount="selectedAccount" :key="(selectedAccount) ? JSON.stringify(selectedAccount) : 'selected'" />
                            </div>
                            <div v-show="selectedTab === 1" :class="{'active show': selectedTab === 1}" id="members" class="tab-pane fade">
                              <members :selectedAccount="selectedAccount"></members>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="provisioning" class="tab-pane fade" v-if="user.userType === 'admin' || user.userType === 'manager' || user.userType === 'super-admin'">
                <CFProvisioning></CFProvisioning>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {db} from "@/firebase/init";
import CFEnterprise from './../../../components/Admin/Cloudflare/enterprise.vue'
import CFProvisioning from './../../../components/Admin/Cloudflare/provisioning.vue'
import swal from "sweetalert2";

export default {
  name: "index",
  data() {
    return {
      selectedTab: 0,
      selectedAccount: null,
      deleting: false,
      selectedItemForView: { cfEnterprise : {}},
      action: '',
      secretEmails: ['sara@bigscoots.com', 'justin@bigscoots.com', 'scott@bigscoots.com', 'khan@bigscoots.com', 'ahmad@bigscoots.com', 'zach@bigscoots.com','les@bigscoots.com'],
      tenantTabVisited: false,
    }
  },
  mounted() {
    if (this.$route.query.tab === 'provisioning') {
      this.$nextTick(() => {
        const el = document.querySelector('a[href="#provisioning"]');
        if (el) el.click();
      });
    }
  },
  components: {
    CFEnterprise,
    CFProvisioning,
    ZoneList: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/ManageTenants/zoneList"
            ),
    Members: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/ManageTenants/members/index"
            ),
    accountsList: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/ManageTenants/accountsList"
            ),
  },
  methods: {
    async addNote() {
      try {
        this.action = 'addNote';
        const ref = await db.collection('domains').doc(this.selectedItemForView.id).update({ cfEnterprise: this.selectedItemForView.cfEnterprise })
      } catch (e) {
        console.log('error when saving note', e.toString())
        swal('Error', 'Something went wrong while saving note.', 'error')
      } finally {
        this.action =  ''
        $('#addNoteModal').modal('hide')
      }
    },
    deleteAccount () {
      swal({
        title: "Are you sure?",
        text: "Are you sure that you want to delete this Account?",
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      })
        .then( async result => {
          if (result.value) {
            try{
              this.deleting= true
              await this.$http.post('tenant/delete-account',{
                grant_type:'token',
                id: this.selectedAccount.id,
              });
              this.selectedAccount = null
              swal({
                title: "Success!",
                text: "You have successfully deleted the account.",
                type: "success"
              })
            }catch (e) {
              console.log('Error from deleting the account' + e.toString())
              swal({
                title: "Error!",
                text: "Something went wrong while deleting the account.",
                type: "error"
              })
            } finally {
              this.deleting=false
            }
          }
        })
    },
    openModal(data) {
      this.selectedItemForView = data;
      console.log('opening modal');
      $('#addNoteModal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
  }
}
</script>

<style scoped lang="scss">
.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5b7cfb;
}
.notes-section {
  background-color: #ef8057;
  color: white;
  border-radius: 3px;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  hr {
    border-top: 1px solid rgba(255,255,255,.5);
  }
}
table{
  tr {
    .task-width {
      width:70%;
    }
    td {
      /deep/  p {
        margin: 0 !important;
      }
    }
  }
}
hr {
  &.h-3 {
    border-top: 3px solid rgba(0,0,0,.1);
  }
}
.pagination{
  display: inline-flex !important;
}
.cf-status-icons {
  i {
    font-size: 25px;
    margin: 0 !important;
    &.disabled {
      color: #7E7E7E;
    }

    &.enabled {
      color: #47f260;
    }

    &.yellow {
      color: #f2b61d;
    }
    &.default {
      color: currentColor;
    }
    &:hover{
      background-color:transparent !important;
      color: currentColor !important;
    }
  }
}
.cpy-btn{
  margin: 0;
}
.fs-10{
  font-size: 10px;
}
.h-43{
  height:43px;
}
.domain-card{
  background: #f0f0f4;
  box-shadow: none;
  border-radius: 8px !important;
  &:hover{
    box-shadow: 0 6px 10px 3px rgba(0, 0, 0, 0.15);;
  }
  .collapse-btn{
    margin-top: 0.5rem !important;
  }
  .domain-head{
    display: flex;
    justify-content: space-between;
    .h5-m0 {
      margin: 0;
    }
    .ul-m0{
      margin: 0;
    }
  }
  .domain-info{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .badge{
      text-transform: none !important;
    }
  }
}
.bl-bt{
  display: flex;
  align-items: flex-end;
  button {
    margin: 0 !important;
  }
}
.cursor-pointer{
  cursor: pointer;
}
pre{
  display: inline-block;
  margin-bottom: 0px;
}
</style>
